import { render, staticRenderFns } from "./DSKHBranch.vue?vue&type=template&id=20d3a288"
import script from "./DSKHBranch.vue?vue&type=script&lang=js"
export * from "./DSKHBranch.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports